import { profileVerified } from "assets";
import UserProfileStory from "components/app/flipflop/user-profile-story/UserProfileStory";

interface UserListState {
  user: any;
}

export default function UserList({ user }: UserListState) {
  return (
    <div className="flex flex-row space-x-2 w-full items-center p-1 rounded-lg cursor-pointer max-w-full overflow-x-hidden hover:bg-muted">
      <UserProfileStory
        user={user}
        className="w-14 h-14 shrink-0"
        isLinkProfile={true}
      />
      <div className="flex w-full max-w-full flex-row justify-between items-center">
        <div className="flex flex-col max-w-full w-full">
          <div className="flex items-center space-x-2 max-w-full">
            <p className="text-sm font-medium line-clamp-1 overflow-hidden">
              {user.name}
            </p>

            {user.is_verified === "Yes" && (
              <img src={profileVerified} alt="" className="w-[15px] h-[15px]" />
            )}
          </div>

          <div className="flex items-center space-x-2 max-w-full">
            <p className="text-xs text-muted-foreground line-clamp-2 overflow-hidden">
              {`${user.no_of_follower ? `${user.no_of_follower} Followers` : ""}
                                          ${
                                            user.no_of_like
                                              ? `• ${user.no_of_like} Likes`
                                              : ""
                                          }
                                      `}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

